import {ScraperCategory} from '../types';
import {
  ABRITEL_LINK,
  ADIDAS_LINK,
  AIRBNB_LINK,
  ALIBABA_LINK,
  ALIEXPRESS_LINK,
  AMAZON_LINK,
  AORUS_LINK,
  APARTMENTS_LINK,
  ApiDetailsLink,
  BESTBUY_LINK,
  BIENICI_LINK,
  BOL_LINK,
  BONS_PLANS_EASYCASH_LINK,
  BOOKING_LINK,
  BOSE_LINK,
  BOULANGER_LINK,
  BROWNS_FASHION_LINK,
  CANADIAN_TIRE_LINK,
  CARTERS_LINK,
  CDISCOUNT_LINK,
  CONFORAMA_LINK,
  CRAIGSLIST_LINK,
  CULTURE_VELO_LINK,
  DELL_LINK,
  DYSON_LINK,
  EBAY_LINK,
  ENTREPARTICULIERS_LINK,
  EPSON_LINK,
  EXPEDIA_LINK,
  FNAC_LINK,
  FOSSIL_LINK,
  FUNDA_LINK,
  G2A_LINK,
  GITES_DE_FRANCE_LINK,
  GOG_LINK,
  HARDWARE_LINK,
  HOTELS_LINK,
  IGVAULT_LINK,
  IMMO_DIFFUSION_LINK,
  INSTANT_GAMING_LINK,
  JDSPORTS_LINK,
  JOHN_LEWIS_LINK,
  JOUECLUB_LINK,
  KAUFPARTS_LINK,
  LA_COMPAGNIE_DU_RHUM_LINK,
  LAMBDA_TEK_LINK,
  LAREDOUTE_LINK,
  LEBONCOIN_LINK,
  LOISIRS3000_LINK,
  MACWAY_LINK,
  MAISONDUMONDE_LINK,
  MATERIELNET_LINK,
  MICROMANIA_LINK,
  NEIMAN_MARCUS_LINK,
  NET_A_PORTER_LINK,
  NIKE_LINK,
  NIKON_LINK,
  OUESTFRANCE_IMMO_LINK,
  PAP_LINK,
  PARUVENDU_LINK,
  PIXMANIA_LINK,
  PLAYMOBIL_LINK,
  PROPERTY_PASS_BOOK_LINK,
  RAKUTEN_LINK,
  REALTOR_LINK,
  RIGHTMOVE_LINK,
  RUE_DU_COMMERCE_LINK,
  SELOGER_LINK,
  SEPHORA_LINK,
  SHOPBOP_LINK,
  SSENSE_LINK,
  SUBITO_LINK,
  TRIANGL_LINK,
  TRULIA_LINK,
  WALMART_LINK,
  WOODBRASS_LINK,
  ZALANDO_LINK,
  ZARA_LINK,
  ZILLOW_LINK,
} from '../utils/constants';
export const ScraperPath: Record<ScraperCategory, string> = {
  [ScraperCategory.Raw]: '/raw-html',
  [ScraperCategory.Retail]: '/retail',
  [ScraperCategory.RealEstate]: '/real-estate',
  [ScraperCategory.SearchEngine]: '/search-engine',
  [ScraperCategory.SocialMedia]: '/data-scraper',
  [ScraperCategory.Campsite]: '/campsite',
  [ScraperCategory.Booking]: '/booking',
  [ScraperCategory.PrestaShop]: '/prestashop',
};

export const ScraperCategoryWebsites: Record<ScraperCategory, string[]> = {
  [ScraperCategory.Raw]: [],
  [ScraperCategory.Retail]: [
    `[boulanger.com](/${ApiDetailsLink(BOULANGER_LINK)})`,
    `[laredoute.fr](/${ApiDetailsLink(LAREDOUTE_LINK)})`,
    `[cdiscount.com](/${ApiDetailsLink(CDISCOUNT_LINK)})`,
    `[rakuten.com](/${ApiDetailsLink(RAKUTEN_LINK)})`,
    `[rakuten.de](/${ApiDetailsLink(RAKUTEN_LINK)})`,
    `[fnac.com](/${ApiDetailsLink(FNAC_LINK)})`,
    `[aorus.com](/${ApiDetailsLink(AORUS_LINK)})`,
    `[sephora.fr](/${ApiDetailsLink(SEPHORA_LINK)})`,
    `[woodbrass.com](/${ApiDetailsLink(WOODBRASS_LINK)})`,
    `[fossil.com](/${ApiDetailsLink(FOSSIL_LINK)})`,
    `[amazon.com](/${ApiDetailsLink(AMAZON_LINK)})`,
    `[amazon.fr](/${ApiDetailsLink(AMAZON_LINK)})`,
    'google.com/shopping',
    `[bestbuy.com](/${ApiDetailsLink(BESTBUY_LINK)})`,
    `[bestbuy.ca](/${ApiDetailsLink(BESTBUY_LINK)})`,
    `[leboncoin.fr](/${ApiDetailsLink(LEBONCOIN_LINK)})`,
    `[subito.it](/${ApiDetailsLink(SUBITO_LINK)})`,
    `[bol.com](/${ApiDetailsLink(BOL_LINK)})`,
    `[walmart.ca](/${ApiDetailsLink(WALMART_LINK)})`,
    `[gog.com](/${ApiDetailsLink(GOG_LINK)})`,
    `[igvault.com](/${ApiDetailsLink(IGVAULT_LINK)})`,
    `[bose.fr](/${ApiDetailsLink(BOSE_LINK)})`,
    `[zara.com](/${ApiDetailsLink(ZARA_LINK)})`,
    'shop.lululemon.com',
    `[canadiantire.ca](/${ApiDetailsLink(CANADIAN_TIRE_LINK)})`,
    `[g2a.com](/${ApiDetailsLink(G2A_LINK)})`,
    'costco.ca',
    `[kaufparts.com](/${ApiDetailsLink(KAUFPARTS_LINK)})`,
    `[lacompagniedurhum.com](/${ApiDetailsLink(LA_COMPAGNIE_DU_RHUM_LINK)})`,
    'dugasclubexpert.fr',
    `[micromania.fr](/${ApiDetailsLink(MICROMANIA_LINK)})`,
    'mistergooddeal.com',
    'alternate.fr',
    `[zalando.fr](/${ApiDetailsLink(ZALANDO_LINK)})`,
    `[bons-plans.easycash.fr](/${ApiDetailsLink(BONS_PLANS_EASYCASH_LINK)})`,
    'asgoodasnew.fr',
    `[instant-gaming.com](/${ApiDetailsLink(INSTANT_GAMING_LINK)})`,
    `[ebay.com](/${ApiDetailsLink(EBAY_LINK)})`,
    `[ebay.fr](/${ApiDetailsLink(EBAY_LINK)})`,
    'darty.com',
    'fnactopachat.com',
    'bonacheter.com',
    'webdistrib.com',
    `[rueducommerce.fr](/${ApiDetailsLink(RUE_DU_COMMERCE_LINK)})`,
    'backmarket.fr',
    `[lambda-tek.fr](/${ApiDetailsLink(LAMBDA_TEK_LINK)})`,
    `[joueclub.fr](/${ApiDetailsLink(JOUECLUB_LINK)})`,
    'tedbaker.com',
    `[nikon.fr](/${ApiDetailsLink(NIKON_LINK)})`,
    `[triangl.com](/${ApiDetailsLink(TRIANGL_LINK)})`,
    'spartoo.com',
    `[pixmania.com](/${ApiDetailsLink(PIXMANIA_LINK)})`,
    `[loisirs3000.fr](/${ApiDetailsLink(LOISIRS3000_LINK)})`,
    'intermarche-shopping.com',
    `[macway.com](/${ApiDetailsLink(MACWAY_LINK)})`,
    `[maisonsdumonde.com](/${ApiDetailsLink(MAISONDUMONDE_LINK)})`,
    'monicavinader.com',
    `[shopbop.com](/${ApiDetailsLink(SHOPBOP_LINK)})`,
    'nordstrom.com',
    'target.com',
    `[playmobil.fr](/${ApiDetailsLink(PLAYMOBIL_LINK)})`,
    'auchan.fr',
    'ldlc.com',
    `[culturevelo.com](/${ApiDetailsLink(CULTURE_VELO_LINK)})`,
    'lebmx.fr',
    `[ssense.com](/${ApiDetailsLink(SSENSE_LINK)})`,
    'lacentrale.fr',
    'eglobalcentral.fr',
    `[aliexpress.com](/${ApiDetailsLink(ALIEXPRESS_LINK)})`,
    `[alibaba.com](/${ApiDetailsLink(ALIBABA_LINK)})`,
    `[shop.hardware.fr](/${ApiDetailsLink(HARDWARE_LINK)})`,
    `[materiel.net](/${ApiDetailsLink(MATERIELNET_LINK)})`,
    'ubaldi.com',
    'grosbill.com',
    `[conforama.fr](/${ApiDetailsLink(CONFORAMA_LINK)})`,
    'psngames.org',
    'asdiscount.com',
    `[nike.com](/${ApiDetailsLink(NIKE_LINK)})`,
    `[epson.fr](/${ApiDetailsLink(EPSON_LINK)})`,
    `[dell.com](/${ApiDetailsLink(DELL_LINK)})`,
    'hiphopshop.gr',
    `[jdsports.fr](/${ApiDetailsLink(JDSPORTS_LINK)})`,
    'tomtom.com',
    'borntobekids.fr',
    'conrad.fr',
    'hightech.leclerc',
    'culture.leclerc',
    'rebuy.fr',
    'play-start.com',
    `[shop.dyson.fr](/${ApiDetailsLink(DYSON_LINK)})`,
    'game.co.uk',
    'takealot.com',
    'leafly.com',
    'theequinewarehouse.ie',
    'fragrancenet.com',
    'trendyol.com',
    'bathandbodyworks.com',
    `[adidas.com](/${ApiDetailsLink(ADIDAS_LINK)})`,
    'victoriassecret.com',
    'razer.com',
    'hm.com',
    `[carters.com](/${ApiDetailsLink(CARTERS_LINK)})`,
    'iherb.com',
    'etsy.com',
    `[brownsfashion.com](/${ApiDetailsLink(BROWNS_FASHION_LINK)})`,
    'matchesfashion.com',
    'alexandalexa.com',
    `[net-a-porter.com](/${ApiDetailsLink(NET_A_PORTER_LINK)})`,
    'amara.com',
    'cb2.com',
    `[neimanmarcus.com](/${ApiDetailsLink(NEIMAN_MARCUS_LINK)})`,
    'coolblue.nl',
    'babypark.nl',
    `[johnlewis.com](/${ApiDetailsLink(JOHN_LEWIS_LINK)})`,
    'koibird.com',
  ],
  [ScraperCategory.RealEstate]: [
    `[bienici.com](/${ApiDetailsLink(BIENICI_LINK)})`,
    `[seloger.com](/${ApiDetailsLink(SELOGER_LINK)})`,
    `[leboncoin.fr](/${ApiDetailsLink(LEBONCOIN_LINK)})`,
    `[rightmove.co.uk](/${ApiDetailsLink(RIGHTMOVE_LINK)})`,
    `[craigslist.org](/${ApiDetailsLink(CRAIGSLIST_LINK)})`,
    `[entreparticuliers.com](/${ApiDetailsLink(ENTREPARTICULIERS_LINK)})`,
    `[immo-diffusion.fr](/${ApiDetailsLink(IMMO_DIFFUSION_LINK)})`,
    `[paruvendu.fr](/${ApiDetailsLink(PARUVENDU_LINK)})`,
    `[pap.fr](/${ApiDetailsLink(PAP_LINK)})`,
    `[ouestfrance-immo.com](/${ApiDetailsLink(OUESTFRANCE_IMMO_LINK)})`,
    `[funda.nl](/${ApiDetailsLink(FUNDA_LINK)})`,
    `[zillow.com](/${ApiDetailsLink(ZILLOW_LINK)})`,
    `[trulia.com](/${ApiDetailsLink(TRULIA_LINK)})`,
    'primeshop.com.hk',
    `[propertypassbook.com](/${ApiDetailsLink(PROPERTY_PASS_BOOK_LINK)})`,
    `[apartments.com](/${ApiDetailsLink(APARTMENTS_LINK)})`,
    `[realtor.com](/${ApiDetailsLink(REALTOR_LINK)})`,
  ],
  [ScraperCategory.SearchEngine]: [
    'google.com',
    'bing.com',
    'yandex.com',
    'duckduckgo.com',
  ],
  [ScraperCategory.SocialMedia]: [
    'facebook.com',
    'instagram.com',
    'twitter.com',
    'linkedin.com',
    'tiktok.com',
    'threads.com',
  ],
  [ScraperCategory.Booking]: [
    `[abritel.fr](/${ApiDetailsLink(ABRITEL_LINK)})`,
    `[expedia.com](/${ApiDetailsLink(EXPEDIA_LINK)})`,
    `[airbnb.fr](/${ApiDetailsLink(AIRBNB_LINK)})`,
    `[hotels.com](/${ApiDetailsLink(HOTELS_LINK)})`,
    `[gites-de-france.com](/${ApiDetailsLink(GITES_DE_FRANCE_LINK)})`,
    `[booking.com](/${ApiDetailsLink(BOOKING_LINK)})`,
  ],
  [ScraperCategory.Campsite]: ['yieldbooking.com'],
  [ScraperCategory.PrestaShop]: [],
};
